"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var mobx_react_1 = require("mobx-react");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var classnames_1 = __importDefault(require("classnames"));
var c = (0, BemBuilder_1.default)("section");
var TableSectionCollapseButton = (0, mobx_react_1.observer)(function (_a) {
    var collapsed = _a.collapsed, toggle = _a.toggle;
    return (react_1.default.createElement(kaleidoscope_1.IconButton, { className: (0, classnames_1.default)(c("collapse-button")), icon: collapsed ? react_1.default.createElement(icons_1.ChevronRight, { key: "collapsed" }) : react_1.default.createElement(icons_1.ChevronDown, { key: "expanded" }), isRound: true, tooltip: {
            content: collapsed ? "Open section" : "Close section",
            className: "qwilr-font",
            targetClassName: c("collapse-button-wrapper"),
        }, onClick: toggle }));
});
exports.default = TableSectionCollapseButton;
